// extracted by mini-css-extract-plugin
export default {"base":"-cm_44a2da2f"};